import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import archivableMixin from './archivableMixin'
import statusesMixin from './statusesMixin'
import vacancyPartiesMixin from './vacancyPartiesMixin'
import { declineApplicationAsFreelancer } from '@/api/vacancies/applications/applications'
import { VACANCIES_MY, VACANCY_DETAILS_ADMIN } from '@/constants/routes'
import responseMixin from '@/mixins/responseMixin'
import Button from '@/models-ts/ui/Button'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [archivableMixin, statusesMixin, vacancyPartiesMixin, responseMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
    }),
    hasDeclineApplicationByFreelancer() {
      return !this.isTemporary && this.isWorker && !this.isDone
    },
    hasDeclineApplicationByCustomer() {
      return !this.isTemporary && this.isEmployer && !this.isDone && !this.isMetaArchived
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    ...mapMutations({
      updateApplication: 'vacancyChat/updateApplication',
    }),

    async declineApplicationByCustomer() {
      googleAnalyticsV2.send({
        event: 'response-to-ftj-job',
        'event-content': 'customer-button-click-decline',
        ftj_id: this.application.vacancyId,
      })
      if (!this.archiving) {
        await this.setArchivedMeta(true)
        this.$router.push({
          name: VACANCY_DETAILS_ADMIN,
          params: { id: this.application.vacancyId },
        })
      }
    },

    declineApplicationByFreelancer() {
      this.openModal({
        component: 'lx-composite-modal-new',
        props: {
          title: 'Cancel application?',
          text: `This application will be removed from Customer's applications list.`,
          buttons: [
            new Button({
              text: 'Cancel',
              classes: 'lx-transparent-blue-btn',
            }),
            new Button({
              text: 'Proceed',
              classes: 'lx-blue-btn',
              onClick: async () => {
                try {
                  await declineApplicationAsFreelancer(this.application.id)
                  this.$router.push({ name: VACANCIES_MY })
                } catch (e) {
                  this.parseError(e)
                }
              },
            }),
          ],
        },
      })
    },
  },
})
